export const fonts = {
  // todo: font 決まり次第 fix
  body: '-apple-system, Arial, "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", メイリオ, Meiryo, "ＭＳ Ｐゴシック", sans-serif',
}
